import { createTheme, type Theme } from "@mui/material/styles";

/**
 * Single MUI theme for the app. All component styling is done via the `sx` prop against these
 * theme tokens — no CSS files and no hardcoded colors outside this definition (Atlas PWA styling).
 * Per-module / light-dark theming can be layered on later; the baseline ships one light theme.
 */
const theme: Theme = createTheme({
	palette: {
		mode: "light",
		primary: {
			main: "#69936C"
		},
		secondary: {
			main: "#3D5A40"
		}
	},
	typography: {
		fontFamily: ["Roboto", "Helvetica", "Arial", "sans-serif"].join(",")
	}
});

export default theme;
